(function () {
    'use strict';

    angular
        .module('procedureControllers')
        .controller('ProcedureEditMetadataController', Controller);

    Controller.$inject = ['$scope', '$state', '$window', '$q', '$modal', 'procedureService', 'permissionService', 'notificationService', 'modalService', 'languageService', 'procedure', 'metadataBlockLookups', 'sectionBlockLookups', 'businessUnits', 'procedureTypes', 'procedureEnums'];

    function Controller($scope, $state, $window, $q, $modal, procedureService, permissionService, notificationService, modalService, languageService, procedure, metadataBlockLookups, sectionBlockLookups, businessUnits, procedureTypes, procedureEnums) {

        $scope.metadataBlockLookups     = metadataBlockLookups;
        $scope.sectionBlockLookups      = sectionBlockLookups;
        $scope.procedure                = procedure;
        $scope.businessUnits            = businessUnits;
        $scope.procedureTypes           = procedureTypes;
        $scope.selectableProcedureTypes = getSelectableProcedureTypes();
        $scope.meetingFrequencies       = initMeetingFrequency();
        $scope.reviewCycles             = initReviewCycle();

        // Pre-select the type of procedure depending on the procedureTypeID
        if (!$scope.procedure.ProcedureID && _.get($scope, 'procedure.MetadataBlock.ProcedureTypeID', false)) {
            var procedureType = getProcedureType();

            if (procedureType) {
                $scope.procedure.MetadataBlock.ProcedureType = procedureType;
            } else {
                delete $scope.procedure.MetadataBlock.ProcedureTypeID;
            }
        }

        $scope.showProcedureCode = false;
        $scope.ctxtCtrl          = {
            isLoading: false,

            isDirty: false,

            // True when user manually changes the Procedure Code Number
            userChangedCodeNumber: false,

            // True to display the Procedure Code
            showProcedureCode: false,

            // Contains the suggested/available Procedure Code
            suggestedProcedureCode: null,

            // Legal Entities lookup attribute values
            selectAllLegalEntities: false,
            allLegalEntitiesAttr: null,
            legalEntityList: null,
            canEditLegalEntities: !!$scope.procedure.MetadataBlock.HasMetadataBlock_AddLegalEntities,

            // Meeting Frequency
            canEditMeetingFrequency: !!$scope.procedure.MetadataBlock.HasMetadataBlock_AddMeetingFrequency,

            // Review Cycle
            canEditReviewCycle: !!$scope.procedure.MetadataBlock.HasMetadataBlock_AddReviewCycle,

            // Objectives
            isObjectivesMandatory: (($scope.procedure.MetadataBlock.HasMandatory_Objectives === undefined) ? true : $scope.procedure.MetadataBlock.HasMandatory_Objectives),

            // Locations lookup attribute values
            selectAllLocations: false,
            allLocationsAttr: null,
            locationList: null,
            canEditLocations: !!$scope.procedure.MetadataBlock.HasMetadataBlock_AddLegalEntities,

            issuingBURequired: isIssuingBusinessUnitRequired(),
            procedureType: _.get(getProcedureType(), 'Value', ''),

            canChangeProcedureType: !$scope.procedure.MetadataBlock.ProcedureTypeID,

            canPublish: false,
            canUnpublish: false,
            canRequestReview: false,

            // Active lang, might be changed in different places, initializes in english
            langAttr: null, // Default set in init
            lang: 'EN'
        };

        // Translations
        $scope.labels = {
            EN: {
                Title: 'Title',
                ProcedureType: 'Procedure Type',
                Committee: 'Committee',
                IssuingBU: 'Issuing Business Unit',
                Objectives: 'Objectives',
                ShortDescription: 'Short Description',
                LegalEntities: 'Legal Entities',
                ReviewCycle: 'Review Cycles',
                MeetingFrequency: 'Meeting Frequency',
                Locations: 'Locations',
                EffectiveDate: 'Effective Date',
                All: 'All',
                ProvideTitle: 'Please provide a title...',
                ProvideObjective: 'Please provide detailed objectives...',
                ProvideShortDesc: 'Please provide a short description...',
                SelectProcedureType: 'Select a Procedure Type',
                SelectIssuerBU: 'Select an Issuer Business Unit',
                SelectLegalEntities: 'You can select one or more Legal Entities...',
                SelectMeetingFrequency: 'You can select a meeting frequency...',
                SelectReviewCycle: 'You can select a review cycle...',
                SelectLocations: 'You can select one or more locations...',
            },
            FR: {
                Title: 'Titre',
                ProcedureType: 'Type de procedure',
                Committee: 'Comité',
                IssuingBU: 'Unité d\'affaire émetrice',
                Objectives: 'Objectifs',
                ShortDescription: 'Description courte',
                LegalEntities: 'Entités légales',
                ReviewCycle: 'Cycle de révision du TOR',
                MeetingFrequency: 'Récurrence du meeting',
                Locations: 'Localisations',
                EffectiveDate: 'Date effective ',
                All: 'Toutes',
                ProvideTitle: 'Veuillez fournir un titre...',
                ProvideObjective: 'Veuillez fournir les objectifs détaillés...',
                ProvideShortDesc: 'Veuilles fournir une courte description...',
                SelectProcedureType: 'Choisir un type de procedure',
                SelectIssuerBU: 'Choisir une unité d\'affaire émetrice',
                SelectLegalEntities: 'Choisissez une à plusieurs entités légales...',
                SelectMeetingFrequency: 'Choisissez une récurrence du meeting...',
                SelectReviewCycle: 'Choisissez une cycle de révision du TOR',
                SelectLocations: 'Choisissez une à plusieurs localisations...',
            }
        };

        var featureRole = null;
        var initialProcedureID = $scope.procedure.ProcedureID;
        var initialProcedureCode = _.get($scope, 'procedure.MetadataBlock.ProcedureCode.Code', null);

        // Legal Entities lookups
        function initLegalEntities() {
            if (!$scope.procedure.MetadataBlock.LegalEntities) {
                $scope.procedure.MetadataBlock.LegalEntities = [];
            }

            _.some($scope.metadataBlockLookups.LegalEntity.LookupAttributeValues, function (entity, idx) {
                if (entity.Value === 'AllLegalEntities') {
                    $scope.ctxtCtrl.allLegalEntitiesAttr = entity;
                    $scope.ctxtCtrl.legalEntityList      = _.clone($scope.metadataBlockLookups.LegalEntity.LookupAttributeValues);
                    $scope.ctxtCtrl.legalEntityList.splice(idx, 1);
                    return true;
                }
                return false;
            });

            _.some($scope.procedure.MetadataBlock.LegalEntities, function (entity) {
                if (entity.Value === 'AllLegalEntities') {
                    $scope.ctxtCtrl.selectAllLegalEntities = true;
                }
                return $scope.ctxtCtrl.selectAllLegalEntities;
            });
        }

        // Meeting Frequency
        function initMeetingFrequency() {
            if (metadataBlockLookups.MeetingFrequency === undefined) {
                return [];
            }

            return metadataBlockLookups.MeetingFrequency.LookupAttributeValues;
        }

        // Review Cycle
        function initReviewCycle() {
            if (metadataBlockLookups.ReviewCycle === undefined) {
                return [];
            }

            return metadataBlockLookups.ReviewCycle.LookupAttributeValues;
        }

        // TODO manage error on empty Location or legalEntities

        // Locations lookups
        function initLocations() {
            if (!$scope.procedure.MetadataBlock.Locations) {
                $scope.procedure.MetadataBlock.Locations = [];
            }

            _.some($scope.metadataBlockLookups.Location.LookupAttributeValues, function (entity, idx) {
                if (entity.Value === 'AllLocations') {
                    $scope.ctxtCtrl.allLocationsAttr = entity;
                    $scope.ctxtCtrl.locationList     = _.clone($scope.metadataBlockLookups.Location.LookupAttributeValues);
                    $scope.ctxtCtrl.locationList.splice(idx, 1);
                    return true;
                }
                return false;
            });

            _.some($scope.procedure.MetadataBlock.Locations, function (entity) {
                if (entity.Value === 'AllLocations') {
                    $scope.ctxtCtrl.selectAllLocations = true;
                }
                return $scope.ctxtCtrl.selectAllLocations;
            });
        }

        function initFeatureRole() {
            if (!$scope.procedure.MetadataBlock.ProcedureType) {
                featureRole = 'ProceduresManagement';
                return;
            }

            switch ($scope.procedure.MetadataBlock.ProcedureType.Value) {
                case 'Corporate-Procedure':
                    featureRole = 'Procedures_CorporateProcedureManagement';
                    break;
                case 'Operational-Procedure':
                    featureRole = 'Procedures_OperationalProcedureManagement';
                    break;
                case 'Reference-Document':
                    featureRole = 'Procedures_ReferenceDocumentsManagement';
                    break;
                case 'Terms-of-Reference':
                    featureRole = 'Procedures_TermOfReferenceManagement';
                    break;
                case 'Terms-of-Reference-Steering':
                    featureRole = 'Procedures_TermOfReferenceSteeringManagement';
                    break;
                default:
                    featureRole = 'ProceduresManagement';
            }
        }

        function initProcedureDraft() {
            if ($scope.procedure.ProcedureID) return;

            if (_.get($scope, 'procedure.MetadataBlock.ProcedureTypeID', false)) {
                $scope.procedureTypeChanged();
            }
        }

        function initFlags() {
            var procedureStatusValue = _.get($scope, 'procedure.ProgressStatus.Value', null);
            $scope.ctxtCtrl.canPublish = $scope.procedure.HasProcedure_Edit && $scope.procedure.CanBePublished;
            $scope.ctxtCtrl.canUnpublish = procedureStatusValue === 'Published';

            var metadataBlockStatusValue = _.get($scope, 'procedure.MetadataBlock.ProgressStatus.Value', null);
            $scope.ctxtCtrl.canRequestReview =
                $scope.procedure.HasProcedure_Review && metadataBlockStatusValue === 'Draft';
            $scope.ctxtCtrl.isReadOnly =
                metadataBlockStatusValue === 'ReviewUpdate'
                || metadataBlockStatusValue === 'ReviewCreation';

            $scope.ctxtCtrl.canReview = $scope.procedure.MetadataBlock.HasMetadataBlock_Review;
        }

        function isIssuingBusinessUnitRequired() {
            if (!$scope.procedure.MetadataBlock.ProcedureTypeID) return false;

            return _.some($scope.procedureTypes, function (procedureType) {
                return procedureType.Value === 'Operational-Procedure'
                    && $scope.procedure.MetadataBlock.ProcedureTypeID === procedureType.LookupAttributeValueID;
            });
        }


        // TODO - When creating a Procedure, we don't have an object to check contextual permissions.
        // We should always ask for a 'Draft', even when Procedure Type changes, to have contextual permissions.

        function canEditLegalEntities() {
            if (!$scope.procedure.MetadataBlock.ProcedureTypeID) return false;

            return permissionService.hasPermission(featureRole, 'MetadataBlock', 'AddLegalEntities');
        }
        function canEditMeetingFrequency() {
            if (!$scope.procedure.MetadataBlock.ProcedureTypeID) return false;

            return permissionService.hasPermission(featureRole, 'MetadataBlock', 'AddMeetingFrequency');
        }
        function canEditReviewCycle() {
            if (!$scope.procedure.MetadataBlock.ProcedureTypeID) return false;

            return permissionService.hasPermission(featureRole, 'MetadataBlock', 'AddReviewCycle');
        }

        function canEditLocations() {
            if (!$scope.procedure.MetadataBlock.ProcedureTypeID) return false;

            return permissionService.hasPermission(featureRole, 'MetadataBlock', 'AddLocations');
        }

        function getSelectableProcedureTypes() {
            if (!$scope.procedureTypes) return [];

            // Remove Reference-Document from the list of selectable procedure types
            var selectableProcedureTypes = _.filter($scope.procedureTypes,
                function (procedureType) {
                    return procedureType.LookupAttributeValueID !== procedureEnums.procedureType.ReferenceDocument;
                });

            return selectableProcedureTypes;
        }

        function getProcedureType() {
            if (!$scope.procedure.MetadataBlock.ProcedureTypeID) return null;

            var procedureType = _.find($scope.procedureTypes,
                function (procedureType) {
                    return $scope.procedure.MetadataBlock.ProcedureTypeID === procedureType.LookupAttributeValueID;
                });

            if (procedureType === undefined && $scope.procedure.MetadataBlock.ProcedureType) {
                procedureType = $scope.procedure.MetadataBlock.ProcedureType;
            }

            return procedureType;
        }

        function displayCannotDeleteModal(references) {
            modalService.displayTemplateModal(
                'References to this Procedure',
                require('../../shared/procedure/prcCannotDeleteProcedure.modal.tpl.html'),
                {
                    ngStyle: {
                        'min-height': '0'
                    },
                    references: references,
                    getUrl: function (reference) {
                        if (reference.ProcedureStatusTitle === 'Draft')
                            return '/Procedure/'
                                + reference.ProcedureTypeValue
                                + '/' + reference.ProcedureCodeFull
                                + '/WorkingCopy#' + reference.Anchor


                            return '/Procedure/'
                                + reference.ProcedureTypeValue
                                + '/' + reference.ProcedureCodeFull
                                + '/Published#' + reference.Anchor


                    }
                },
                true,
                false
            );
        }

        function refreshProcedure() {
            return procedureService.getProcedureForEdit(
                $scope.procedure.MetadataBlock.ProcedureType.Value,
                $scope.procedure.MetadataBlock.ProcedureCode.Code)
                .then(function (refreshedProcedure) {
                    $scope.procedure = refreshedProcedure;
                    init();
                })
        }

        function init() {
            $scope.ctxtCtrl.langAttr = _.find(sectionBlockLookups.Language.LookupAttributeValues, {Value: 'EN'});

            initFeatureRole();
            initProcedureDraft();
            initLegalEntities();
            initLocations();
            initFlags();
        }

        // Page is Dirty
        $scope.pageIsDirty = function() {
            $scope.ctxtCtrl.isDirty = true;
        };

        // Language Changed
        $scope.setLanguage = function (lang) {
            $scope.ctxtCtrl.lang     = lang.Value;
            $scope.ctxtCtrl.langAttr = lang;
        };

        // Get Language Prefix when none in english
        $scope.getLangPrefix = function() {
            return $scope.ctxtCtrl.lang === 'EN' ? '' : $scope.ctxtCtrl.lang;
        };

        $scope.focusOnCode = function () {
            document.getElementById('procedureCodeNumber').focus();
        };

        $scope.displayProcedureVersion = function () {
            if ($scope.procedure.ProcedureID) {
                return 'v.' + $scope.procedure.Version;
            }
            return 'new';
        };

        $scope.getSelectedBusinessUnitText = function () {
            return $scope.procedure.MetadataBlock.IssuerBusinessUnit.TitleEN;
        };

        $scope.getBusinessUnitLabel = function (businessUnit) {
            return _.times(businessUnit.Depth, function () {
                return '<span class="margin-lg-left"></span>';
            }).join('') + (businessUnit['Title'+$scope.ctxtCtrl.lang] || businessUnit.TitleEN);
        };

        // Can Approve Review
        $scope.canApproveReview = function () {
            return $scope.procedure.HasProcedure_Review
                && $scope.procedure.MetadataBlock.ReviewRequesterID !== $scope.authenticatedUser.ItemPersonID;
        };

        // Model changed
        $scope.metadataChanged = function () {
            $scope.ctxtCtrl.isDirty = true;
        };

        // Meeting Frequency Changed
        $scope.meetingFrequencyChanged = function() {
            $scope.procedure.MetadataBlock.MeetingFrequencyID = $scope.procedure.MetadataBlock.MeetingFrequency.LookupAttributeValueID;
            $scope.ctxtCtrl.isDirty = true;
        };

        // Review Cycle Changed
        $scope.reviewCycleChanged = function() {
            $scope.procedure.MetadataBlock.ReviewCycleID = $scope.procedure.MetadataBlock.ReviewCycle.LookupAttributeValueID;
            $scope.ctxtCtrl.isDirty = true;
        };

        // Procedure Type Changed
        $scope.procedureTypeChanged = function () {
            if ($scope.procedure.ProcedureID) return;

            $scope.procedure.MetadataBlock.ProcedureTypeID = $scope.procedure.MetadataBlock.ProcedureType.LookupAttributeValueID;

            initFeatureRole();

            $scope.ctxtCtrl.issuingBURequired    = isIssuingBusinessUnitRequired();
            $scope.ctxtCtrl.canEditLegalEntities = canEditLegalEntities();
            $scope.ctxtCtrl.canEditMeetingFrequency = canEditMeetingFrequency();
            $scope.ctxtCtrl.canEditReviewCycle = canEditReviewCycle();

            $scope.ctxtCtrl.canEditLocations     = canEditLocations();

            // Empty Legal Entities if can't edit anymore
            if (!$scope.ctxtCtrl.canEditLegalEntities) {
                $scope.procedure.MetadataBlock.LegalEntities = [];
                $scope.ctxtCtrl.selectAllLegalEntities = false;
            }

            // Empty Locations if can't edit anymore
            if (!$scope.ctxtCtrl.canEditLocations) {
                $scope.procedure.MetadataBlock.Locations = [];
                $scope.ctxtCtrl.selectAllLocations = false;
            }

            // Empty Meeting Frequency if can't edit anymore
            if (!$scope.ctxtCtrl.canEditMeetingFrequency) {
                delete $scope.procedure.MetadataBlock.MeetingFrequencyID;
            }
            // Empty Meeting Frequency if can't edit anymore
            if (!$scope.ctxtCtrl.canEditReviewCycle) {
                delete $scope.procedure.MetadataBlock.ReviewCycleID;
            }

            // Empty Issuing BU if can't edit anymore
            if (!$scope.ctxtCtrl.issuingBURequired) {
                delete $scope.procedure.MetadataBlock.IssuerBusinessUnitID;
            }

            delete $scope.procedure.MetadataBlock.ProcedureCode;
            $scope.updateProcedureCode();
        };

        // Update Code
        $scope.updateProcedureCode = function (userChangedCodeNb) {
            $scope.ctxtCtrl.isLoading             = true;
            $scope.ctxtCtrl.isDirty               = true;
            $scope.ctxtCtrl.userChangedCodeNumber = !!userChangedCodeNb;

            if ($scope.procedure.MetadataBlock.IssuerBusinessUnitID || !$scope.ctxtCtrl.issuingBURequired) {
                if (_.get($scope.procedure.MetadataBlock, 'ProcedureCode.CodeNumber')) {
                    $scope.procedure.MetadataBlock.ProcedureCode.CodeNumber
                        = Number($scope.procedure.MetadataBlock.ProcedureCode.CodeNumber);
                }

                // Get suggested code with current number
                procedureService.getAvailableProcedureCode(
                    $scope.procedure.MetadataBlock
                ).then(function (availableCode) {
                        if (!availableCode) return;

                        var newOrNoPrefix     = !$scope.procedure.MetadataBlock.ProcedureCode
                            || (availableCode.CodePrefix !== $scope.procedure.MetadataBlock.ProcedureCode.CodePrefix),
                            codeNumberChanged = $scope.procedure.MetadataBlock.ProcedureCode
                                && availableCode.CodeNumber !== $scope.procedure.MetadataBlock.ProcedureCode.CodeNumber;

                        if (!newOrNoPrefix && codeNumberChanged && $scope.ctxtCtrl.userChangedCodeNumber) {
                            $scope.procedureMetadataBlock.codeNumber.$setValidity('invalidCodeNumber', false);
                            $scope.ctxtCtrl.suggestedProcedureCode = availableCode;
                        } else {
                            $scope.procedure.MetadataBlock.ProcedureCode = availableCode;
                            $scope.procedureMetadataBlock.codeNumber.$setValidity('invalidCodeNumber', true);
                        }
                    })
                    .finally(function () {
                        $scope.ctxtCtrl.isLoading = false;
                    });

            }
        };

        $scope.updateSelectAllEntities = function () {
            $scope.ctxtCtrl.isDirty = true;
            if ($scope.ctxtCtrl.selectAllLegalEntities) {
                $scope.procedure.MetadataBlock.LegalEntities.length = 0;
                $scope.procedure.MetadataBlock.LegalEntities.push($scope.ctxtCtrl.allLegalEntitiesAttr);
            } else {
                $scope.procedure.MetadataBlock.LegalEntities.length = 0;
            }
        };

        // Display Selected Legal Entities
        $scope.displaySelectedLegalEntities = function() {
            return _.join(_.map($scope.procedure.MetadataBlock.LegalEntities, function (legalEntity) {
                return languageService.translateProperty(legalEntity, {
                    default: 'TitleEN',
                    fr: 'TitleFR'
                }, $scope.ctxtCtrl.lang);
            }), ', ');
        };

        $scope.updateSelectAllLocations = function () {
            $scope.ctxtCtrl.isDirty = true;
            if ($scope.ctxtCtrl.selectAllLocations) {
                $scope.procedure.MetadataBlock.Locations.length = 0;
                $scope.procedure.MetadataBlock.Locations.push($scope.ctxtCtrl.allLocationsAttr);
            } else {
                $scope.procedure.MetadataBlock.Locations.length = 0;
            }
        };

        // Display Selected Locations
        $scope.displaySelectedLocations = function() {
            return _.join(_.map($scope.procedure.MetadataBlock.Locations, function (location) {
                return languageService.translateProperty(location, {
                    default: 'TitleEN',
                    fr: 'TitleFR'
                }, $scope.ctxtCtrl.lang);
            }), ', ');
        };

        // Create or Update
        $scope.createOrUpdateProcedure = function () {
            if ($scope.procedureMetadataBlock.$invalid) return false;

            $scope.ctxtCtrl.isLoading = true;

            var promise;
            var successMsg;
            $scope.procedure.MetadataBlock.EffectiveDate = new Date(new Date($scope.procedure.MetadataBlock.EffectiveDate).setUTCHours(0,0,0,0))
            if ($scope.procedure.ProcedureID) {
                promise = procedureService.updateProcedureMetadataBlock(
                    $scope.procedure.ProcedureID,
                    $scope.procedure.MetadataBlock,
                    $scope.procedure.MetadataBlock.ProcedureType.Value);
                successMsg = 'Procedure updated successfully';
            } else {
                promise = procedureService.createProcedureAndMetadataBlock(
                    $scope.procedure.MetadataBlock,
                    $scope.procedure.MetadataBlock.ProcedureType.Value);
                successMsg = 'Procedure created successfully';
            }

            promise
                .then(function (createdMetadataBlock) {
                    notificationService.notify(successMsg);

                    // Created procedure, go to sections
                    if (!initialProcedureID) {
                        $state.go(
                            'procedure.edit', {
                                ProcedureType: createdMetadataBlock.ProcedureType.Value,
                                ProcedureCode: createdMetadataBlock.ProcedureCode.Code
                            },
                            { reload: true, location: 'replace' }
                        );
                        return;
                    }

                    // Code or ID changed, navigate
                    if (createdMetadataBlock.ProcedureID !== initialProcedureID
                        || createdMetadataBlock.ProcedureCode.Code !== initialProcedureCode) {

                        $state.go(
                            'procedure.edit.metadata', {
                                ProcedureType: createdMetadataBlock.ProcedureType.Value,
                                ProcedureCode: createdMetadataBlock.ProcedureCode.Code
                            },
                            { reload: true, location: 'replace' }
                        );
                        return;
                    }

                    $scope.procedure.MetadataBlock = createdMetadataBlock;
                    $scope.ctxtCtrl.isDirty = false;

                    return refreshProcedure();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        // Request MetadataBlock Review
        $scope.requestReview = function () {
            $scope.ctxtCtrl.isLoading = true;

            procedureService
                .requestReviewMetadataBlock(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID,
                    $scope.procedure.MetadataBlock.MetadataBlockID
                )
                .then(function (updatedMetadataBlock) {
                    $scope.procedure.MetadataBlock = updatedMetadataBlock;
                    initFlags();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                })
        };

        // Review Metadata Block
        $scope.reviewMetadataBlock = function () {
            var modalScope = $scope.$new();
            var modal;

            modalScope.isLoading = false;

            // Close Modal
            modalScope.close = function () {
                modal.$promise.then(modal.hide);
            };

            // Cancel Review
            modalScope.cancelReview = function() {
                if (modalScope.isLoading) return;

                modalScope.isLoading = true;

                procedureService
                    .cancelReviewMetadataBlock(
                        $scope.procedure.MetadataBlock.ProcedureType.Value,
                        $scope.procedure.ProcedureID,
                        $scope.procedure.MetadataBlock.MetadataBlockID)
                    .then(function (updatedMetadataBlock) {
                        $scope.procedure.MetadataBlock = updatedMetadataBlock;
                        initFlags();

                        notificationService.notify('Procedure metadata review cancelled');
                        modalScope.close();
                    })
                    .finally(function () {
                        modalScope.isLoading = false;
                    });
            };

            // Approve Review
            modalScope.approveReview = function() {
                if (modalScope.isLoading) return;

                modalScope.isLoading = true;

                procedureService
                    .approveReviewMetadataBlock(
                        $scope.procedure.MetadataBlock.ProcedureType.Value,
                        $scope.procedure.ProcedureID,
                        $scope.procedure.MetadataBlock.MetadataBlockID)
                    .then(function (updatedMetadataBlock) {
                        $scope.procedure.MetadataBlock = updatedMetadataBlock;

                        notificationService.notify('Procedure metadata reviewed successfully');
                        modalScope.close();

                        return refreshProcedure();
                    })
                    .finally(function () {
                        modalScope.isLoading = false;
                    });
            };

            // Get versions to compare
            procedureService
                .getMetadataBlocksToCompare(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID,
                    $scope.procedure.MetadataBlock.MetadataBlockID)
                .then(function (blocksToCompare) {
                    modalScope.previous = blocksToCompare.Previous;
                    modalScope.next = blocksToCompare.Next;
                    modalScope.isComparing = modalScope.previous && modalScope.next;

                    modal = $modal({
                        scope: modalScope,
                        template: '/app/Main/procedure/procedureMetadataReview.modal.tpl.html',
                        placement: 'center'
                    });
                });
        };

        // Delete Procedure
        $scope.deleteProcedure = function () {
            $scope.ctxtCtrl.isLoading = true;

            procedureService
                .checkIfCanSafelyDelete(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID
                )
                .then(function (references) {
                    if (references.length) {
                        displayCannotDeleteModal(references);

                        return $q.reject();
                    }

                    return procedureService
                        .deleteProcedure(
                            $scope.procedure.MetadataBlock.ProcedureType.Value,
                            $scope.procedure.ProcedureID)

                })
                .then(function () {
                    $state.go('home', {
                        UserItemPersonID: $scope.authenticatedUser.ItemPersonID,
                        q: "type=Procedure"
                    }, {
                        location: 'replace'
                    });
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        // Cancel
        $scope.cancel = function () {
            if (!$scope.procedure.ProcedureID && $window.history.back.length > 0) {
                $window.history.back();
                return;
            }
            if (!$scope.procedure.ProcedureID && !$window.history.back.length) {
                $window.close();
                return;
            }
            $state.go(
                'procedure.edit', {
                    ProcedureType: $scope.procedure.MetadataBlock.ProcedureType.Value,
                    ProcedureCode: $scope.procedure.MetadataBlock.ProcedureCode.Code
                },
                { reload: true }
            );
        };

        // Publish
        $scope.publish = function () {
            $scope.ctxtCtrl.isLoading = true;

            procedureService
                .publishProcedure(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID)
                .then(function () {
                    $state.reload();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        // Unpublish
        $scope.unpublish = function () {
            $scope.ctxtCtrl.isLoading = true;

            procedureService
                .unpublishProcedure(
                    $scope.procedure.MetadataBlock.ProcedureType.Value,
                    $scope.procedure.ProcedureID)
                .then(function () {
                    $state.reload();
                })
                .finally(function () {
                    $scope.ctxtCtrl.isLoading = false;
                });
        };

        init();
    }
})();
